import { format } from "date-fns";

import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";
import { LanguageType } from "@/translations";

const CHANGED_AT_FORMAT = "dd.MM.yyyy HH:mm";

/** Deliberately not `formatTimestamp`, which prefixes the weekday and appends "Uhr". */
export function formatChangedAt(date: Date, language: LanguageType): string {
  return format(date, CHANGED_AT_FORMAT, { locale: locales[language] });
}
